import { render, staticRenderFns } from "./extra-projekte-status.vue?vue&type=template&id=2f748403&lang=pug&"
import script from "./extra-projekte-status.vue?vue&type=script&lang=js&"
export * from "./extra-projekte-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports